export default "<span [ngClass]=\"{'operation-delete': this.operation === 'DELETE'}\" class=\"operation\">\n    {{operation}}\n</span>"